import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Loader from 'react-spinners/BarLoader';
import { toast } from 'react-toastify';
import API from 'api/API';
import { FileService } from 'services/FileService';
import { useUser } from 'store/user/useUser';
import { delay } from 'utils/helpers/delay.helpers';

const QualityRecordDownload: React.FC = () => {
  const { deliveryCode = '', setCode = '' } = useParams<{ deliveryCode: string; setCode: string }>();
  const [recordFile, setRecordFile] = useState<string>('');
  const { isAuthenticated } = useUser();

  const getQualityRecordUrl = useCallback(async () => {
    try {
      const response = await API.qualityRecords.getQualityRecord({
        set_code: setCode,
        delivery_code: deliveryCode,
      });
      const qualityRecordUrl = response.quality_report_pdf || '';
      // delaying so that we are waiting for the firebase token when accessing this link directly
      // in an unauthenticated state.
      await delay(6000);
      const file = await FileService.getFile(qualityRecordUrl, true, true);
      setRecordFile(file);
      window.location.href = file;
    } catch {
      toast.error('Error fetching quality record');
    }
  }, [deliveryCode, setCode]);

  useEffect(() => {
    if (isAuthenticated) {
      getQualityRecordUrl();
    }
  }, [setCode, getQualityRecordUrl, isAuthenticated]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      {!recordFile && <Loader />}
    </div>
  );
};

export default QualityRecordDownload;
